// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DTADetailsAuditTrailInner
 */
export interface DTADetailsAuditTrailInner {
    /**
     * 
     * @type {object}
     * @memberof DTADetailsAuditTrailInner
     */
    details: object;
    /**
     * 
     * @type {string}
     * @memberof DTADetailsAuditTrailInner
     */
    event: string;
    /**
     * 
     * @type {string}
     * @memberof DTADetailsAuditTrailInner
     */
    timestamp: string;
    /**
     * 
     * @type {string}
     * @memberof DTADetailsAuditTrailInner
     */
    user: string;
}

/**
 * Check if a given object implements the DTADetailsAuditTrailInner interface.
 */
export function instanceOfDTADetailsAuditTrailInner(value: object): value is DTADetailsAuditTrailInner {
    if (!('details' in value) || value['details'] === undefined) return false;
    if (!('event' in value) || value['event'] === undefined) return false;
    if (!('timestamp' in value) || value['timestamp'] === undefined) return false;
    if (!('user' in value) || value['user'] === undefined) return false;
    return true;
}

export function DTADetailsAuditTrailInnerFromJSON(json: any): DTADetailsAuditTrailInner {
    return DTADetailsAuditTrailInnerFromJSONTyped(json, false);
}

export function DTADetailsAuditTrailInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): DTADetailsAuditTrailInner {
    if (json == null) {
        return json;
    }
    return {
        
        'details': json['details'],
        'event': json['event'],
        'timestamp': json['timestamp'],
        'user': json['user'],
    };
}

export function DTADetailsAuditTrailInnerToJSON(json: any): DTADetailsAuditTrailInner {
    return DTADetailsAuditTrailInnerToJSONTyped(json, false);
}

export function DTADetailsAuditTrailInnerToJSONTyped(value?: DTADetailsAuditTrailInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'details': value['details'],
        'event': value['event'],
        'timestamp': value['timestamp'],
        'user': value['user'],
    };
}
